
import React, { PureComponent } from 'react';

class ContentBlock extends PureComponent { 
    render() {
        const { blockTitle, textContent } = this.props;
        return (
            <div className="about-content">
                <p className="about-title" dangerouslySetInnerHTML={{__html: blockTitle}} />
                <p className="about-text" dangerouslySetInnerHTML={{__html: textContent}} />
            </div>
        )
    }
}
    
export default ContentBlock;



// WEBPACK FOOTER //
// ./src/About/ContentBlock.js